import { API, graphqlOperation } from "aws-amplify";
import { 
  createUserInfo, 
  createUserWatchSubscriptionInfo,
  deleteUserWatchSubscriptionInfo,
  updateUserInfo,
  updateUserWatchSubscriptionInfo
} from "../../graphql/mutations";
import {
  userWatchSubscriptionInfosByUserinfoID,
  getUserInfo,
  listWatchListingsByDate
} from "../../graphql/queries";
import logger from "./logger";

export function registerUser(username, email) {
  return API.graphql(
    graphqlOperation(createUserInfo, {input: { 
      id: username, 
      email, 
      collector: false, 
      emailAcknowledged: false, 
      phoneAcknowledged: false, 
      weeklyEmailCount: 0, 
      weeklyTextCount: 0 
    }})
  ).then((res) => {
    return res;
  }).catch(logger.error);
}

export function getUser(id) {
  return API.graphql(
    graphqlOperation(getUserInfo, { id })
  ).then((res) => {
    return res;
  }).catch(logger.error);
}

// throws exception to be caught in front end
export function updateUserPhoneNumber(username, phone, phoneValidationCode, phoneValidated) {
  return API.graphql(
    graphqlOperation(updateUserInfo, {input: { id: username, phone, phoneAcknowledged: true, phoneValidationCode, phoneValidated }})
  ).then((res) => res);
}

export function addUserWatchSubscription(userinfoID, brand, description, ttl) {
  return API.graphql(
    graphqlOperation(createUserWatchSubscriptionInfo, {input: {brand, description, userinfoID, ttl, notifyEmail: true, notifyPhone: false}})
  ).then((res) => {
    return res;
  }).catch(logger.error);
}

export function getUserSubscriptions(userinfoID) {
  return API.graphql(
    graphqlOperation(userWatchSubscriptionInfosByUserinfoID, { userinfoID })
  ).then((res) => {
    return res.data.userWatchSubscriptionInfosByUserinfoID.items;
  }).catch(logger.error);
}

export function deleteUserSubscription(id) {
  return API.graphql(
    graphqlOperation(deleteUserWatchSubscriptionInfo, {input: { id }})
  ).then((res) => {
    return res;
  }).catch(logger.error);
}

export function refreshUserSubscription(id, ttl) {
  return API.graphql(
    graphqlOperation(updateUserWatchSubscriptionInfo, {input: { id, ttl }})
  ).then((res) => {
    return res;
  }).catch(logger.error);
}

export function updateUserSubscriptionNotifyEmail(id, notifyEmail) {
  return API.graphql(
    graphqlOperation(updateUserWatchSubscriptionInfo, {input: { id, notifyEmail }})
  ).then((res) => {
    return res;
  }).catch(logger.error);
}

export function updateUserSubscriptionNotifyPhone(id, notifyPhone) {
  return API.graphql(
    graphqlOperation(updateUserWatchSubscriptionInfo, {input: { id, notifyPhone }})
  ).then((res) => {
    return res;
  }).catch(logger.error);
}

export function getWatchListings() {
  return API.graphql(
    graphqlOperation(listWatchListingsByDate, { type: "WatchListing", limit: 5, sortDirection: "DESC" })
  ).then((res) => {
    return res;
  }).catch(logger.error);
}

